import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const StudentStore = () => {
  const [items, setItems] = useState([]);
  const [schoolId, setSchoolId] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          // ✅ Use UID to fetch user doc (safer for rules)
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          const userData = userDoc.exists() ? userDoc.data() : null;

          if (userData?.schoolId) {
            setSchoolId(userData.schoolId);
          }
        } catch (err) {
          console.error('Failed to fetch user profile:', err);
        }
      }
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    if (!schoolId) return;

    const fetchItems = async () => {
      try {
        const storeRef = collection(db, 'schools', schoolId, 'store');
        const querySnapshot = await getDocs(storeRef);
        const availableItems = querySnapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(item => item.available);

        setItems(availableItems);
      } catch (err) {
        console.error('Failed to fetch store items:', err);
      }
    };

    fetchItems();
  }, [schoolId]);

  return (
    <div className="dashboard-container">
      <h1 className="section-title">PBIS Store</h1>

      <div
        className="section-card"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '1.5rem',
        }}
      >
        {items.map((item) => (
          <div
            key={item.id}
            style={{
              width: '200px',
              border: '1px solid #ddd',
              borderRadius: '10px',
              padding: '0.75rem',
              background: '#fff',
              boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
              textAlign: 'center',
            }}
          >
            <img
              src={item.imageUrl}
              alt={item.name}
              style={{
                width: '100%',
                height: '100px',
                objectFit: 'contain',
                borderRadius: '8px',
                marginBottom: '0.5rem',
                backgroundColor: '#f0f0f0',
              }}
            />
            <h4 style={{ margin: '0.5rem 0 0.25rem' }}>{item.name}</h4>
            <p style={{ fontSize: '0.9rem', color: '#444' }}>
              {item.ticketCost} tickets
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentStore;